import { Grid, Checkbox } from "@material-ui/core";
import { useContext } from "react";
import { TemplateContractsContext } from "../contexts/ContractsContext";
import Fieldset from "../../../../components/basics/Fieldset";
import { HeaderAccordion, CheckItem } from "../styles/ModalContracts";
import Chip from "../../../../components/basics/Chip";
import ContractsController from "../controller/ContractsController";

const AcordionContractsCompany = ({ location }) => {
  const { companyList } = useContext(TemplateContractsContext);
  const { handleCheckCompany } = ContractsController();
  return (
    <>
      <Fieldset
        titulo={
          <HeaderAccordion>
            <Grid container spacing={2}>
              <Grid item xs>
                <Chip label="EMPRESAS" bgcolor="secondary" />
              </Grid>
            </Grid>
          </HeaderAccordion>
        }
        bgcolor="white"
        textcolor="black"
        accordion
        defaultExpanded={false}
      >
        <Grid item container spacing={1}>
          <Grid item container xs={6}>
            <Grid item container xs alignContent="center">
              {companyList.map((Company) => (
                <CheckItem
                  key={Company.id}
                  control={
                    <Checkbox
                      checked={Company.check}
                      onChange={() => {
                        handleCheckCompany(Company.id);
                      }}
                    />
                  }
                  label={Company.apelido}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Fieldset>
    </>
  );
};

export default AcordionContractsCompany;
